import { render, staticRenderFns } from "./ChangeClassStudent.vue?vue&type=template&id=17578c66&scoped=true"
import script from "./ChangeClassStudent.vue?vue&type=script&lang=js"
export * from "./ChangeClassStudent.vue?vue&type=script&lang=js"
import style0 from "./ChangeClassStudent.vue?vue&type=style&index=0&id=17578c66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17578c66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17578c66')) {
      api.createRecord('17578c66', component.options)
    } else {
      api.reload('17578c66', component.options)
    }
    module.hot.accept("./ChangeClassStudent.vue?vue&type=template&id=17578c66&scoped=true", function () {
      api.rerender('17578c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/ChangeClassStudent.vue"
export default component.exports